module.exports = __webpack_public_path__ + "img/order-down.c13605ab.svg";